import {
  BANK_ACCOUNT_DIALOG_MESSAGES,
  BankAccountDialogMessages,
} from "./bank-account-dialog.messages";

export type AccountInfoMessages = BankAccountDialogMessages & {
  accountInfoTitle: string;
  businessDataTitle: string;
  accountStatusTitle: string;
  accountStatusDescription: string;
  commercialDataCompletion: string;
  editCommercialDataText: string;
  editCommercialDataLinkText: string;
  editCommercialDataHref: string;
  documentSubmission: string;
  sendDocumentsText: string;
  sendDocumentsLinkText: string;
  sendDocumentsHref: string;
  generalApproval: string;
  generalApprovalDescription: string;
  approvedLabel: string;
  rejectedLabel: string;
  pendingLabel: string;
  awaitingApprovalLabel: string;
  unknownStatusLabel: string;

  // Labels para campos de informações da conta
  idLabel: string;
  nameLabel: string;
  emailLabel: string;
  loginEmailLabel: string;
  mobilePhoneLabel: string;
  addressLabel: string;
  addressNumberLabel: string;
  complementLabel: string;
  provinceLabel: string;
  postalCodeLabel: string;
  cpfCnpjLabel: string;
  personTypeLabel: string;
  personTypeFisicaLabel: string;
  personTypeJuridicaLabel: string;
  companyTypeLabel: string;
  cityLabel: string;
  stateLabel: string;
  countryLabel: string;
  walletIdLabel: string;
  apiKeyLabel: string;
  accountLabel: string;
  accountDigitLabel: string;
  incomeValueLabel: string;
  incomeRangeLabel: string;
  companyTypeMEILabel: string;
  companyTypeLimitedLabel: string;
  companyTypeIndividualLabel: string;

  businessDataTabLabel: string;
  bankAccountTabLabel: string;

  banksAccountsTitleCard: string;
  noBankAccountMessage: string;
  noBankAccountDescription: string;
  addBankAccountButtonLabel: string;

  anticipationToggleLabel: string;
  anticipationToggleHint: string;
  anticipationConfirmTitle: string;
  anticipationConfirmDescription: string;
  anticipationConfirmButton: string;
  anticipationEnabledToast: string;
  anticipationDisabledToast: string;
  anticipationErrorTitle: string;
  anticipationErrorCloseButton: string;
  anticipationErrorPrerequisites: string;
  anticipationGenericError: string;
};

export const ACCOUNT_INFO_MESSAGES: AccountInfoMessages = {
  accountInfoTitle: "Informações da Conta",
  businessDataTitle: "Dados Comerciais",
  accountStatusTitle: "Situação da Conta",
  accountStatusDescription: "Confira abaixo as pendências para a validação do seu cadastro:",
  commercialDataCompletion: "Preenchimento dos Dados Comerciais",
  editCommercialDataText: " para editar seus dados comerciais.",
  editCommercialDataLinkText: "Clique aqui",
  editCommercialDataHref: "/editar-dados-comerciais",
  documentSubmission: "Envio de documentos",
  sendDocumentsText: " para enviar seus documentos.",
  sendDocumentsLinkText: "Clique aqui",
  sendDocumentsHref: "/enviar-documentos",
  generalApproval: "Aprovação geral:",
  generalApprovalDescription:
    "O cadastro somente pode ir para aprovação após finalizadas as etapas anteriores.",
  approvedLabel: "Aprovado",
  rejectedLabel: "Rejeitado",
  pendingLabel: "Pendente",
  awaitingApprovalLabel: "Aguardando Aprovação",
  unknownStatusLabel: "Status Desconhecido",
  idLabel: "ID",
  nameLabel: "Nome da empresa",
  emailLabel: "E-mail",
  loginEmailLabel: "E-mail de Login",
  mobilePhoneLabel: "Telefone Celular",
  addressLabel: "Endereço",
  addressNumberLabel: "Número",
  complementLabel: "Complemento",
  provinceLabel: "Bairro",
  postalCodeLabel: "CEP",
  cpfCnpjLabel: "CPF/CNPJ",
  personTypeLabel: "Tipo de Pessoa",
  personTypeFisicaLabel: "Pessoa Física",
  personTypeJuridicaLabel: "Pessoa Jurídica",
  companyTypeLabel: "Tipo de Empresa",
  cityLabel: "Cidade",
  stateLabel: "Estado",
  countryLabel: "País",
  walletIdLabel: "ID da Carteira",
  apiKeyLabel: "Chave API",
  accountLabel: "Conta",
  incomeValueLabel: "Valor da Renda",
  incomeRangeLabel: "Faixa de Renda",
  companyTypeMEILabel: "Microempreendedor Individual (MEI)",
  companyTypeLimitedLabel: "Empresa Limitada (LTDA)",
  companyTypeIndividualLabel: "Empresário Individual",
  businessDataTabLabel: "Dados Comerciais",
  bankAccountTabLabel: "Conta Bancária",

  banksAccountsTitleCard: "Contas Bancárias",
  noBankAccountMessage: "Você ainda não cadastrou nenhuma conta.",
  noBankAccountDescription:
    "Caso queira solicitar a transferência do seu saldo Talk2Pay para outro banco, você precisa cadastrar sua conta bancária.",
  addBankAccountButtonLabel: "Adicionar conta",

  anticipationToggleLabel: "Ativar antecipação de pagamentos",
  anticipationToggleHint: "(sujeito a taxas de antecipação)",
  anticipationConfirmTitle: "Ativar antecipação",
  anticipationConfirmDescription:
    "Ao ativar, os pagamentos de cartão de crédito serão antecipados automaticamente, sujeitos a taxas de antecipação.",
  anticipationConfirmButton: "Ativar",
  anticipationEnabledToast: "Antecipação automática ativada.",
  anticipationDisabledToast: "Antecipação automática desativada.",
  anticipationErrorTitle: "Não foi possível ativar a antecipação",
  anticipationErrorCloseButton: "Fechar",
  anticipationErrorPrerequisites:
    "Para ativar, o cadastro precisa estar aprovado e a conta precisa ter selfie aprovada ou uma transferência Pix/TED já concluída.",
  anticipationGenericError: "Não foi possível atualizar a antecipação automática.",

  ...BANK_ACCOUNT_DIALOG_MESSAGES,
};
